import { render, staticRenderFns } from "./CashiaAppLogo.vue?vue&type=template&id=5999dce3"
import script from "./CashiaAppLogo.vue?vue&type=script&lang=js"
export * from "./CashiaAppLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports